/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dashboard_Overview_MobileInputs */

const he_dashboard_overview_mobile = /** @type {(inputs: Dashboard_Overview_MobileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`נייד`)
};

const en_dashboard_overview_mobile = /** @type {(inputs: Dashboard_Overview_MobileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mobile`)
};

/**
* | output |
* | --- |
* | "Mobile" |
*
* @param {Dashboard_Overview_MobileInputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const dashboard_overview_mobile = /** @type {((inputs?: Dashboard_Overview_MobileInputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dashboard_Overview_MobileInputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_dashboard_overview_mobile(inputs)
	return en_dashboard_overview_mobile(inputs)
});